<app-release-list [data]="releases"></app-release-list>
